<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Add Booster Driver Reward
        </v-card-title>
        <v-card-text>
          <div v-for="(level, index) in form.pointRange" :key="index">
            <v-row>
              <v-col cols="12" class="d-flex align-center">
                <h4 style="display: inline">Level {{ index + 1 }}</h4>
                <v-btn
                  v-if="form.pointRange.length > 1"
                  icon
                  class="ml-2"
                  color="red"
                  @click="removeLevel(index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.min_driver"
                  label="Min Driver"
                  outlined
                  :error-messages="errors.min_driver"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.max_driver"
                  label="Max Driver"
                  outlined
                  :error-messages="errors.max_driver"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.points_per_driver"
                  label="Points per Driver"
                  outlined
                  :error-messages="errors.points_per_driver"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <v-btn class="mt-2 mb-4" color="secondary" @click="addLevel">
            <v-icon left>mdi-plus</v-icon>
            Add Next Level
          </v-btn>

          <v-divider class="my-5"></v-divider>

          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Save Booster Driver Reward
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "BoosterDriverRewardCreatePage",
  data() {
    return {
      form: {
        pointRange: [
          {
            min_driver: null,
            max_driver: null,
            points_per_driver: null,
          },
        ],
      },
      isLoading: false,
    };
  },
  methods: {
    addLevel() {
      this.form.pointRange.push({
        min_driver: null,
        max_driver: null,
        points_per_driver: null,
      });
    },
    removeLevel(index) {
      this.form.pointRange.splice(index, 1);
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post("/booster_driver_rewards", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.back();
      } catch (e) {
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
